// extracted by mini-css-extract-plugin
export default {"products":"eB-z","card":"fB-z","oosMessaging":"gB-z"};